import Vue from 'vue';
import { useElementUIDatePickerOptions } from '@/composables/useElementUIDatePickerOptions';

/**
 * Vue plugin for Element UI date picker options backward compatibility.
 * Provides global $pickerOptions property via Vue.prototype for legacy code support.
 *
 * @deprecated Use the composable `useElementUIDatePickerOptions()` directly in new code.
 * Migration: Replace `this.$pickerOptions` with `const pickerOptions = useElementUIDatePickerOptions()`
 */

// Usa il composable moderno per fornire le stesse opzioni
const defaultPickerOptions = useElementUIDatePickerOptions();

/**
 * Plugin implementation that registers $pickerOptions on Vue prototype.
 * @description Maintains backward compatibility with legacy Vue.prototype pattern for date picker options.
 */
const Plugin = {
	/**
	 * Installs the plugin on Vue.
	 * @param Vue - Vue constructor
	 */
	install(Vue) {
		// Mantiene la proprietà globale per retrocompatibilità
		Vue.prototype.$pickerOptions = defaultPickerOptions;
	},
};

Vue.use(Plugin);
export default Plugin;
